<template>
  <sub-page :title="title">
    <div class="svc-page">
      <!-- 表单/查询条件区 -->
      <div class="form-card" v-if="mode !== 'list'">
        <template v-for="(item, idx) in items">
          <!-- 多行输入（申请说明类） -->
          <div class="field-block" v-if="item.type === 'textarea'" :key="idx">
            <span class="field-label" :class="{ required: item.required !== false }">{{ item.label }}</span>
            <textarea
              class="field-area"
              rows="3"
              :placeholder="item.placeholder || '请输入' + item.label"
              v-model="item.value"
            ></textarea>
          </div>
          <!-- 单行输入 -->
          <div class="field-row" v-else :key="'r' + idx">
            <span class="field-label" :class="{ required: item.required !== false }">{{ item.label }}</span>
            <input
              class="field-input"
              :type="item.type || 'text'"
              :placeholder="item.placeholder || '请输入' + item.label"
              v-model="item.value"
              :maxlength="item.maxlength || 50"
            />
          </div>
        </template>
      </div>

      <!-- 操作按钮：查询/提交 -->
      <div class="btn-bar" v-if="mode !== 'list'">
        <button class="submit-btn" @click="handleAction">{{ mode === 'query' ? '查询' : '提交' }}</button>
      </div>

      <!-- 查询结果/直接列表 -->
      <template v-if="mode === 'list' || searched">
        <div class="result-title">{{ mode === 'query' ? '查询结果' : '列表' }}</div>
        <div class="result-card" v-for="(row, ri) in displayRows" :key="ri">
          <div class="result-line" v-for="(val, key) in row" :key="key">
            <span class="line-label">{{ key }}</span>
            <span class="line-value">{{ val }}</span>
          </div>
        </div>
        <div class="empty-tip" v-if="displayRows.length === 0">暂无记录</div>
      </template>

      <!-- 底部说明 -->
      <div class="page-tip" v-if="tip">{{ tip }}</div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'SvcPage',
  components: { SubPage },
  data() {
    const meta = this.$route.meta || {}
    // 未配置字段时按模式给默认字段：查询页=证件号码，表单页=姓名+证件号码
    let fields = meta.fields
    if (!fields) {
      fields = meta.mode === 'query'
        ? [{ label: '证件号码' }]
        : [{ label: '姓名' }, { label: '证件号码' }]
    }
    return {
      mode: meta.mode || 'form',
      title: meta.title || '',
      tip: meta.tip || '',
      success: meta.success || '提交成功，业务已受理',
      items: fields.map(f => Object.assign({ value: '' }, f)),
      staticRows: meta.rows || [],
      searched: false
    }
  },
  computed: {
    // 查询/列表展示行：未配置时给通用办件结果演示
    displayRows() {
      if (this.staticRows.length) return this.staticRows
      return [{ '办件编号': 'JS2026RS1003', '业务名称': this.title, '办理状态': '已办结', '办结日期': '2026-09-28' }]
    }
  },
  methods: {
    handleAction() {
      // 必填校验（字段 required !== false 均必填）
      for (const item of this.items) {
        if (item.required !== false && !item.value) {
          this.$alert('请输入' + item.label)
          return
        }
      }
      if (this.mode === 'query') {
        this.searched = true
      } else {
        this.$alert(this.success)
      }
    }
  }
}
</script>

<style scoped>
.svc-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(60 * var(--w));
}
.form-card {
  background: #fff;
  margin-top: calc(24 * var(--w));
}
.field-row {
  display: flex;
  align-items: center;
  height: calc(110 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
}
.field-row:last-child {
  border-bottom: none;
}
.field-label {
  font-size: calc(32 * var(--w));
  color: #323233;
  white-space: nowrap;
  width: calc(200 * var(--w));
  flex-shrink: 0;
}
.field-label.required::before {
  content: '*';
  color: #f56c6c;
  margin-right: calc(4 * var(--w));
}
.field-input {
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  font-size: calc(32 * var(--w));
  color: #323233;
  background: transparent;
  font-family: inherit;
}
.field-input::placeholder {
  color: #969799;
}
.field-block {
  padding: calc(28 * var(--w)) calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
}
.field-block .field-label {
  width: auto;
  display: block;
}
.field-area {
  margin-top: calc(20 * var(--w));
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  font-size: calc(32 * var(--w));
  color: #323233;
  line-height: 1.5;
  font-family: inherit;
  background: #F8F9FB;
  border-radius: calc(8 * var(--w));
  padding: calc(20 * var(--w));
  box-sizing: border-box;
}
.field-area::placeholder {
  color: #969799;
}
.btn-bar {
  padding: calc(48 * var(--w)) calc(32 * var(--w)) 0;
}
.submit-btn {
  width: 100%;
  height: calc(96 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(38 * var(--w));
  border: none;
  border-radius: calc(48 * var(--w));
  cursor: pointer;
  font-family: inherit;
}
.submit-btn:active {
  background: #2578DB;
}
.result-title {
  margin: calc(40 * var(--w)) calc(32 * var(--w)) calc(20 * var(--w));
  font-size: calc(34 * var(--w));
  font-weight: 500;
  color: #323233;
}
.result-card {
  background: #fff;
  border-radius: calc(16 * var(--w));
  margin: 0 calc(24 * var(--w)) calc(24 * var(--w));
  padding: calc(28 * var(--w)) calc(32 * var(--w));
}
.result-line {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: calc(10 * var(--w)) 0;
}
.line-label {
  font-size: calc(30 * var(--w));
  color: #969799;
  flex-shrink: 0;
  margin-right: calc(24 * var(--w));
}
.line-value {
  font-size: calc(32 * var(--w));
  color: #323233;
  text-align: right;
  word-break: break-all;
}
.empty-tip {
  text-align: center;
  color: #969799;
  font-size: calc(32 * var(--w));
  padding: calc(120 * var(--w)) 0;
}
.page-tip {
  margin: calc(20 * var(--w)) calc(32 * var(--w)) 0;
  font-size: calc(28 * var(--w));
  color: #969799;
  line-height: 1.7;
}
</style>



// WEBPACK FOOTER //
// src/pages/SvcPage.vue